// src/components/AnnouncementToast.tsx
import { X } from 'lucide-react'
import React from 'react'

type Props = {
  title: string
  body: string
  /** Change this to show the toast again for a new announcement */
  campaignId: string // e.g. "points-alloc-2025w39"
  /** Optional: restrict visibility to a route (default '/dashboard') */
  route?: string
}

const LS_KEY = (id: string) => `announcement:dismissed:${id}`

const AnnouncementToast: React.FC<Props> = ({ title, body, campaignId }) => {
  const [visible, setVisible] = React.useState(false)

  React.useEffect(() => {
    const dismissed = localStorage.getItem(LS_KEY(campaignId)) === '1'
    if (!dismissed) setVisible(true)
    else setVisible(false)
  }, [campaignId, visible])

  const dismiss = React.useCallback(() => {
    localStorage.setItem(LS_KEY(campaignId), '1')
    setVisible(false)
  }, [campaignId,])


  
  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Announcement"
      className={[
        'absolute top-20 left-1/2 -translate-x-1/2 z-50',
        'w-[calc(100%-16px)] md:w-[364px]',
        'rounded-2xl bg-white/65 backdrop-blur-md ring-1 ring-black/10',
        'shadow-[0_18px_50px_-18px_rgba(0,0,0,0.45)]',
        'px-4 py-3 md:px-5 md:py-4',
        'transition-all duration-200',
        'top-[calc(env(safe-area-inset-top,0px)+${12 + offsetPx}px)]',
      ].join(' ')}
      style={{
        ...(!visible && { display: 'none' }),
      }}
    >
      <div className="flex items-start gap-3">
        <div className="min-w-0 flex-1">
          <div className="text-lg font-semibold leading-tight">{title}</div>
          <div className="text-sm text-neutral-700 mt-1">{body}</div>
        </div>
        <button aria-label="Dismiss announcement" onClick={dismiss} className="w-8 h-8 grid place-items-center rounded-full hover:bg-neutral-100 active:bg-neutral-200 transition">
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  )
}

export default AnnouncementToast
